import { UserService } from './../../../core/services/user.service';
import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { takeUntil } from 'rxjs';
import { GroupService } from 'src/app/core/services/group.service';
import { BaseComponent } from './../../../core/components/base/base.component';
import { ProcedureCode } from './../../../core/services/app-data.service';
import { FeedbackService } from './../../../core/services/feedback.service';
import { CodingBundleSettingsComponent } from './coding-bundle-settings/coding-bundle-settings.component';

@Component({
  selector: 'app-billing-settings',
  templateUrl: './billing-settings.component.html',
  styleUrls: ['./billing-settings.component.scss']
})
export class BillingSettingsComponent extends BaseComponent {

  @ViewChild('codingBundleSettings') codingBundleSettings?: CodingBundleSettingsComponent

  group?: any;
  isSupportUser: boolean = false;


  constructor(
    private groupService: GroupService,
    private userService: UserService,
    fs: FeedbackService,
    md: MatDialog) {
    super(fs, md);
    this.groupService.selectedGroup$
      .pipe(takeUntil(this.destroy$))
      .subscribe(selectedGroup => {
        if (selectedGroup) {
          this.group = selectedGroup;
        }
      });

    this.userService.userProfile$.subscribe(user => {
      if (user && (user.id === '511f39e1-ff14-4a6d-b35a-6fcc22923b50' || user.id === '8f78c3c3-032e-4d2d-8ab3-d4209bb0a305')) {
        this.isSupportUser = true;
      } else {
        this.isSupportUser = false;
      }
    });
  }


  openAddBundleDialog(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.codingBundleSettings?.openAddBundleDialog();
  }

  onProcedureCodesChanged(codes: ProcedureCode[]) {
    const sub = this.groupService.updateGroupModifiers(this.group.id, codes)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          sub.unsubscribe();
          //this.showToastMessage('Coding settings updated successfully');
        },
        (error) => {
          console.error('Error updating coding settings:', error);
          this.showToastMessage('There was an error updating your coding settings. Please try again.');
          sub.unsubscribe();
        }
      );
  }


}
